import {
  SharePreviewProps,
  getOfficePreviewEmbedUrl,
} from 'components/ShareDocument/SharePreviewContent/sharePreviewHelpers';

const OfficePreview = ({ url, filename }: SharePreviewProps) => (
  <iframe
    src={getOfficePreviewEmbedUrl(url)}
    title={`preview-${filename}`}
    className='attachment-preview-iframe attachment-preview-iframe-contained'
    loading='lazy'
    referrerPolicy='no-referrer'
  />
);

export default OfficePreview;
